<template>
  <div class="login-flow">
    <img class="image-container" :src="require('@/assets/hero-login.svg')">
    <div class="content">
      <enter-phone-number :next="redirectToEnterCode"/>
      <login-support-footer :link-action="openLoginHelpModal" />
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';

import Segment from '../../../../Segment';
import router from '../../../../router';
import EnterPhoneNumber from './steps/EnterPhoneNumber.vue';
import ModalBus from '../../../../event-bus/modal-bus';
import LoginHelp from './steps/LoginHelp.vue';

export default {
  name: 'LoginEnterPhoneNumber',
  components: {
    EnterPhoneNumber,
    LoginSupportFooter: BaseUI.LoginSupportFooter,
  },
  created() {
    Segment.trackUserGot('LoginEntered');
  },
  methods: {
    redirectToEnterCode(phoneNumber) {
      const queryParams = { ...this.$route.query, phoneNumber };
      router.push({ path: '/login-enter-code', query: queryParams });
    },
    openLoginHelpModal() {
      ModalBus.$emit('open', {
        component: LoginHelp,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .login-flow {
    .image-container {
      width: 100%;
    }

    .content {
      margin: 30px;
    }
  }
</style>
